import { Injectable } from '@angular/core';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { Subject, Subscription, filter, map, tap } from 'rxjs';

import { SubtitlesValidateService } from '../subtitles-validate/subtitles-validate.service';

@Injectable()
export class SubtitlesUploaderService {
    private _dropped$ = new Subject<NgxFileDropEntry[]>();

    dropped$ = this._dropped$.pipe(
        filter((files) => Boolean(files) && Boolean(files[0])),
        map((files) => files[0].fileEntry as FileSystemFileEntry),
    );

    private readonly subscriptions$ = new Subscription();

    constructor(private subtitlesValidateService: SubtitlesValidateService) {}

    init() {
        this.subtitlesValidateService.init();
        this.subscriptions$.add(this.dropped$.pipe(tap((file) => this.onFileDropped(file))).subscribe());
    }

    destroy() {
        this.subscriptions$.unsubscribe();
        this.subtitlesValidateService.destroy();
    }

    onDropped(files: NgxFileDropEntry[]) {
        this._dropped$.next(files);
    }

    private onFileDropped(fileEntry: FileSystemFileEntry) {
        fileEntry.file((file) => this.subtitlesValidateService.validate(file));
    }
}
